export enum ReportType {
    TRANSACTIONS = "Transactions",
    STATEMENT = "Statement",
    RECONCILIATION = "Reconciliation",
    FUNDING = "Funding",
}
